import { gql } from '@apollo/client'

export const GET_SCENARIO_OBSTACLES = gql`
  query getScenarioObstacles($id: String!) {
    scenario(id: $id) {
      id
      obstacles {
        id
        name
        geojson
        geom_guid
      }
    }
  }
`

export const GET_SCENARIO_ATTACKS = gql`
  query getScenarioAttacks($id: String!) {
    scenario(id: $id) {
      id
      attacks {
        id
        name
        geojson
        line_color
        start_speed
        end_speed
        geom_guid
        original_id
        recalculated_id
        path_length
        vehicle
      }
    }
  }
`

export const GET_SCENARIO = gql`
  query getScenario($id: String!) {
    scenario(id: $id) {
      id
      obstacles {
        id
        name
        geojson
        geom_guid
      }
      attacks {
        id
        name
        geojson
        line_color
        start_speed
        end_speed
        geom_guid
        original_id
        recalculated_id
        path_length
        vehicle
      }
    }
  }
`
export const CREATE_SCENARIO_CHILD = gql`
  mutation createScenarioChild($input: ScenarioInput!) {
    createOrUpdateScenario(input: $input) {
      id
    }
  }
`
